import React from 'react';

function ChamadoRetomarCard({ onRetomar, loading }) {
    return (
        <div className="chamado-sidebar-card chamado-retomar-card">
            <h4 className="chamado-sidebar-card-titulo">Chamado encerrado</h4>
            <p className="chamado-retomar-desc small text-muted mb-2">
                Status, play/pause e conclusão estão bloqueados. Para voltar a atender, use o botão abaixo.
            </p>
            <button
                type="button"
                className="chamado-action-btn chamado-action-retomar w-100"
                onClick={onRetomar}
                disabled={loading}
                title="Retomar atendimento deste chamado"
            >
                <i className="fas fa-redo" aria-hidden="true" /> {loading ? 'Retomando...' : 'Retomar atendimento'}
            </button>
        </div>
    );
}

export default ChamadoRetomarCard;
